module.exports = __webpack_public_path__ + "media/assets/icons/clarity_house-line-527e0b7a280fad38d319e67436bbd309.svg";